import api from "api/flexapi";
import * as types from "./messagingActionTypes";
import { SubmissionError, reset } from "redux-form";

const unreadMessageCountRefreshRateInSeconds = 60;

const getById = body =>
  body.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.pkMessage]: curr,
    };
  }, {});

export const searchMessages = keyWord => dispatch => {
  dispatch({
    type: types.MESSAGING_ROOT_MESSAGE_BEGIN,
    payload: { isfetching: true },
  });
  api
    .searchMessages(keyWord)
    .then(response => {
      const { body = [] } = response;
      const byId = getById(body);

      dispatch({
        type: types.MESSAGING_ROOT_MESSAGE_SUCCESS,
        payload: {
          rootMessages: {
            byId,
            messages: response.body,
          },
          isfetching: false,
          isfetched: true,
        },
      });
    })
    .catch(err =>
      dispatch({
        type: types.MESSAGING_ROOT_MESSAGE_ERROR,
        payload: {
          error: err.response ? err.response.body : err,
          isfetched: true,
          isfetching: false,
        },
      })
    );
};

export const getRootMessages = () => dispatch => {
  dispatch({
    type: types.MESSAGING_ROOT_MESSAGE_BEGIN,
    payload: { isfetching: true },
  });

  api
    .getRootMessages()
    .then(response => {
      const { body = [] } = response;
      const byId = getById(body);

      dispatch({
        type: types.MESSAGING_ROOT_MESSAGE_SUCCESS,
        payload: {
          rootMessages: {
            byId,
            messages: response.body,
          },
          isfetching: false,
          isfetched: true,
        },
      });
    })
    .catch(err =>
      dispatch({
        type: types.MESSAGING_ROOT_MESSAGE_ERROR,
        payload: {
          error: err.response ? err.response.body : err,
          isfetched: true,
          isfetching: false,
        },
      })
    );
};

export const getChildrenMessages = pkMessage => dispatch => {
  dispatch({
    type: types.MESSAGING_CHILDREN_MESSAGE_BEGIN,
    payload: { childrenMessages: { isfetching: true, isfetched: false } },
  });

  api
    .getChildrenMessages(pkMessage)
    .then(response => {
      const { body = [] } = response;
      const byId = getById(body);

      dispatch({
        type: types.MESSAGING_CHILDREN_MESSAGE_SUCCESS,
        payload: {
          childrenMessages: {
            byId,
            messages: response.body,
            isfetching: false,
            isfetched: true,
          },
        },
      });
    })
    .catch(err =>
      dispatch({
        type: types.MESSAGING_CHILDREN_MESSAGE_ERROR,
        payload: {
          error: err.response ? err.response.body : err,
          childrenMessages: {
            isfetching: false,
            isfetched: true,
          },
        },
      })
    );
};

export const postMessage = (data, dispatch) => {
  dispatch({
    type: types.MESSAGING_POST_MESSAGE_BEGIN,
    payload: {
      MESSAGING_POST_MESSAGE_BEGIN: true,
      MESSAGING_ON_POST_MESSAGE_SUCCESS: false,
      MESSAGING_POST_MESSAGE_SUCCESS: false,
    },
  });
  const { attachments = [], ...restData } = data;
  return Promise.all(attachments.map(item => api.uploadMessageAttachment(item)))
    .then(response => {
      const attachmentIds = response.map(r => r.body.pkDigitalContent);
      return api.postMessage({ ...restData, attachmentIds: attachmentIds });
    })
    .catch(err => {
      dispatch({
        type: types.MESSAGING_POST_MESSAGE_ERROR,
        payload: {
          MESSAGING_POST_MESSAGE_BEGIN: false,
          MESSAGING_ON_POST_MESSAGE_SUCCESS: false,
          MESSAGING_POST_MESSAGE_SUCCESS: false,
          MESSAGING_POST_MESSAGE_ERROR: err.response ? err.response.body : err,
        },
      });
      throw new SubmissionError({
        _error: err.response ? err.response.body : err,
      });
    });
};

export const postMessageSuccess = (response, props) => dispatch => {
  dispatch(reset("ComposeMessageForm"));
  dispatch({
    type: types.MESSAGING_POST_MESSAGE_SUCCESS,
    payload: {
      MESSAGING_POST_MESSAGE_BEGIN: false,
      MESSAGING_ON_POST_MESSAGE_SUCCESS: true,
      MESSAGING_POST_MESSAGE_SUCCESS: false,
    },
  });
};

export const onConfirmPost = () => dispatch => {
  dispatch({
    type: types.MESSAGING_ON_POST_MESSAGE_SUCCESS,
    payload: {
      MESSAGING_POST_MESSAGE_BEGIN: false,
      MESSAGING_ON_POST_MESSAGE_SUCCESS: false,
      MESSAGING_POST_MESSAGE_SUCCESS: true,
    },
  });
};

export const getUnreadMessageCount = () => dispatch => {
  dispatch({
    type: types.MESSAGING_GET_UNREAD_COUNT_BEGIN,
    payload: {},
  });

  api
    .getUnreadMessageCount()
    .then(response => {
      dispatch({
        type: types.MESSAGING_GET_UNREAD_COUNT_SUCCESS,
        payload: Object.assign({ unreadMessageCount: response.body }),
      });
    })
    .catch(err =>
      dispatch({
        type: types.MESSAGING_GET_UNREAD_COUNT_ERROR,
        payload: err.response ? err.response.body : err,
      })
    )
    .finally(() => {
      setTimeout(() => {
        getUnreadMessageCount()(dispatch);
      }, unreadMessageCountRefreshRateInSeconds * 1000);
    });
};



// WEBPACK FOOTER //
// ./actions/messagingActions.js